import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //console.log('intercept')
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        //untill mvc returns a 401 check the url
        //console.log(error.url.indexOf('ReturnUrl') > -1)
        if (error.url.indexOf('ReturnUrl') > -1) {
          this.router.navigate(['/logout']);
        }
        //.net mvc its all 200 afetr the 302 we dont see
        //if (error.status === 401 || error.status === 440 || error.status === 302) {
        //  // Redirect to login page
        //  this.router.navigate(['/login']);
        //}
        return throwError(error);
      })
    );
  }
}
